import React from 'react';
import classNames from 'classnames';
import { ATMLabel, IATMLabelProps } from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { RequestStatus } from 'src/constants';
import styles from './status-request.module.scss';

type IProps = {
  status?: string;
  className?: string;
};

const StatusRequest: React.FC<IProps> = ({ status = null, className }) => {
  if (!status) {
    return null;
  }

  let color: IATMLabelProps['customcolor'];
  let reqStatus = Lang.LBL_PENDING_APPROVAL;

  switch (status) {
    case RequestStatus.Cancelled: {
      color = 'lightgrey';
      reqStatus = Lang.LBL_CANCELLED;
      break;
    }

    case RequestStatus.PendingApproval: {
      color = 'lightorange';
      reqStatus = Lang.LBL_PENDING_APPROVAL;
      break;
    }

    case RequestStatus.InFlight: {
      color = 'lightgreen';
      reqStatus = Lang.LBL_IN_FLIGHT;
      break;
    }

    case RequestStatus.Approved: {
      color = 'lightteal';
      reqStatus = Lang.LBL_APPROVED;
      break;
    }

    case RequestStatus.Completed: {
      color = 'lightblue';
      reqStatus = Lang.LBL_COMPLETED;
      break;
    }

    case RequestStatus.RequiresFlightCost: {
      color = 'lightviolet';
      reqStatus = Lang.LBL_FLIGHT_COST_REQUIRES;
      break;
    }

    case RequestStatus.Declined: {
      color = 'lightred';
      reqStatus = Lang.LBL_DECLINED;
      break;
    }
  }

  return (
    <ATMLabel
      className={classNames(styles.container, className)}
      horizontal
      customcolor={color}
    >
      {reqStatus}
    </ATMLabel>
  );
};

export default StatusRequest;
